import { render, staticRenderFns } from "./ProfileVector.vue?vue&type=template&id=93deac24&scoped=true&"
import script from "./ProfileVector.vue?vue&type=script&lang=js&"
export * from "./ProfileVector.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVector.vue?vue&type=style&index=0&id=93deac24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93deac24",
  null
  
)

export default component.exports